import React from 'react';
import { Routes } from '../Core/Constants';

export default class ReturnRequestForm extends React.Component {
	constructor(props) {
		super(props);
		const { orderData } = props;
		const items = (orderData.items || []).map(item => ({
			...item,
			selected: false,
			quantity: item.quantity,
			maxQuantity: item.quantity
		}));
		this.state = {
			items,
			reason: '',
			note: '',
			bankAccount: '',
			submitting: false,
			error: ''
		};
	}

	toggleAll = () => {
		const allSelected = this.state.items.every(i => i.selected);
		this.setState({ items: this.state.items.map(i => ({ ...i, selected: !allSelected })) });
	}

	toggleItem = (idx) => {
		const items = [...this.state.items];
		const wasSelected = items[idx].selected;
		items[idx] = { ...items[idx], selected: !wasSelected };
		this.setState({ items });
	}

	setQuantity = (idx, val) => {
		const items = [...this.state.items];
		const max = items[idx].maxQuantity;
		const qty = Math.max(1, Math.min(max, parseInt(val) || 1));
		items[idx] = { ...items[idx], quantity: qty };
		this.setState({ items });
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const T = window.Texts.returnRequest;
		const selectedItems = this.state.items.filter(i => i.selected);
		if (selectedItems.length === 0) {
			this.setState({ error: T.selectAtLeastOne });
			return;
		}
		
		if (this.props.orderData.isBankAccountRequired && !this.state.bankAccount.trim()) {
			this.setState({ error: T.bankAccountRequired });
			return;
		}
		this.setState({ submitting: true, error: '' });
		const payload = {
			token: this.props.token,
			items: selectedItems.map(i => ({
				orderedProductId: i.orderedProductId,
				quantity: i.quantity
			})),
			reason: this.state.reason || null,
			note: this.state.note || null,
			bankAccount: this.state.bankAccount || null
		};
		this.props.onSubmit(payload, () => {
			this.setState({ submitting: false });
		});
	}

	formatDate = (dateStr) => {
		if (!dateStr) return '';
		const d = new Date(dateStr);
		return d.toLocaleDateString();
	}

	render() {
		const T = window.Texts.returnRequest;
		const { orderData } = this.props;
		return (
			<div className="return-request-form">
				<div className="cover">
					<div className="headline">
						<h1>{T.formTitle}</h1>
					</div>
					<div className="inner-700">
						<table border="0" cellPadding="0" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '18px' }}>
							<tbody>
								<tr>
									<td style={{ padding: '6px 0', fontWeight: 'bold', width: '40%' }}>{T.orderLabel}:</td>
									<td style={{ padding: '6px 0' }}>{orderData.invoiceCode}</td>
								</tr>
								<tr>
									<td style={{ padding: '6px 0', fontWeight: 'bold' }}>{T.orderDateLabel}:</td>
									<td style={{ padding: '6px 0' }}>{this.formatDate(orderData.orderDate)}</td>
								</tr>
								{orderData.withdrawalDeadline && (
									<tr>
										<td style={{ padding: '6px 0', fontWeight: 'bold' }}>{T.deadlineLabel}:</td>
										<td style={{ padding: '6px 0' }}>{this.formatDate(orderData.withdrawalDeadline)}</td>
									</tr>
								)}
							</tbody>
						</table>

						{(orderData.customerName || orderData.customerEmail) && (
							<div style={{ marginBottom: '18px', padding: '12px', background: '#f8f8f8', borderRadius: '4px' }}>
								<strong style={{ display: 'block', marginBottom: '8px' }}>{T.customerInfoLabel}</strong>
								{orderData.customerName && <div>{orderData.customerName}</div>}
								{orderData.customerAddress && <div>{orderData.customerAddress}</div>}
								{(orderData.customerZip || orderData.customerCity) && (
									<div>{[orderData.customerZip, orderData.customerCity].filter(Boolean).join(' ')}</div>
								)}
								{orderData.customerEmail && <div>{orderData.customerEmail}</div>}
								{orderData.customerPhone && <div>{orderData.customerPhone}</div>}
							</div>
						)}

						{!orderData.isBankAccountRequired && (
							<p style={{ marginBottom: '14px', fontSize: '13px', color: '#555' }}>{T.refundInfoText}</p>
						)}

						{this.state.error && (
							<p className="missing-entry"><strong>{this.state.error}</strong></p>
						)}

						<form onSubmit={this.handleSubmit}>
							<div className="box form-box">
								<div className="form-group">
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px', flexWrap: 'wrap', gap: '10px' }}>
										<label style={{ marginBottom: 0 }}><strong>{T.selectItemsLabel}</strong></label>
										<label style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginBottom: 0, userSelect: 'none' }}>
											<input
												type="checkbox"
												checked={this.state.items.length > 0 && this.state.items.every(i => i.selected)}
												onChange={this.toggleAll}
												style={{ width: '22px', height: '22px', cursor: 'pointer', margin: 0, verticalAlign: 'middle' }}
											/>
											<span style={{ fontSize: '14px', fontWeight: 'bold', cursor: 'pointer' }}>
												{this.state.items.every(i => i.selected) ? T.deselectAllBtn : T.selectAllBtn}
											</span>
										</label>
									</div>
									<table border="0" cellPadding="0" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '8px' }}>
										<tbody>
											{this.state.items.map((item, idx) => (
												<tr key={item.orderedProductId} style={{ borderBottom: '1px solid #eee' }}>
													<td style={{ padding: '8px 4px', width: '36px', verticalAlign: 'middle' }}>
														<input
															type="checkbox"
															checked={item.selected}
															onChange={() => this.toggleItem(idx)}
															style={{ width: '20px', height: '20px', cursor: 'pointer', margin: 0, verticalAlign: 'middle' }}
														/>
													</td>
													<td style={{ padding: '8px 4px' }}>
														<span style={{ fontWeight: item.selected ? 'bold' : 'normal' }}>
															{item.productName}
														</span>
														{item.productCode && (
															<span style={{ color: '#888', marginLeft: '8px', fontSize: '12px' }}>
																{item.productCode}
															</span>
														)}
													</td>
													<td style={{ padding: '8px 4px', textAlign: 'right', width: '140px' }}>
														{item.selected && (
															<>
																<label style={{ marginRight: '6px', fontSize: '13px' }}>{T.quantityLabel}:</label>
																<input
																	type="number"
																	min="1"
																	max={item.maxQuantity}
																	value={item.quantity}
																	onChange={e => this.setQuantity(idx, e.target.value)}
																	style={{ width: '55px', textAlign: 'center' }}
																	className="form-control"
																/>
																<span style={{ marginLeft: '4px', fontSize: '13px', color: '#888' }}>/ {item.maxQuantity}</span>
															</>
														)}
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>

								<div className="form-group" style={{ marginTop: '14px' }}>
									<label>{T.reasonLabel}</label>
									<textarea
										className="form-control"
										rows="3"
										value={this.state.reason}
										onChange={e => this.setState({ reason: e.target.value })}
									/>
								</div>

								<div className="form-group" style={{ marginTop: '14px' }}>
									<label>{T.noteLabel}</label>
									<textarea
										className="form-control"
										rows="3"
										value={this.state.note}
										onChange={e => this.setState({ note: e.target.value })}
									/>
								</div>

								{orderData.isBankAccountRequired && (
									<div className="form-group">
										<label>{T.bankAccountLabel} *</label>
										<input
											type="text"
											className="form-control"
											value={this.state.bankAccount}
											onChange={e => this.setState({ bankAccount: e.target.value })}
										/>
									</div>
								)}


								<div style={{ display: 'flex', alignItems: 'center' }}>
									<button
										type="submit"
										className="btn btn50 iconed icon-continue"
										disabled={this.state.submitting}
									>
										<span>{T.submitBtn}</span>
									</button>
									{orderData.orderPublicIdentifier && (
										<a
											href={Routes.OrderView + '/' + orderData.orderPublicIdentifier}
											style={{ marginLeft: 'auto' }}
										>
											{T.orderDetailBtn}
										</a>
									)}
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}
